module.exports = __webpack_public_path__ + "img/logo-full.316fef84.png";